import { hardwareUnitsOps } from "../api/operations";
import { TFunction } from "i18next";
import { ROLE } from "../Auth/useRole";
import { entityFactory } from "../hooks/useEntity";
import { defineEntity } from "../api/entity";

const conf = defineEntity({
  ...entityFactory("hardware-unit"),
  endpoint: "hardware-units",
  operations: hardwareUnitsOps,
  roleView: [ROLE.HARDWARE_UNIT_VIEW, ROLE.HARDWARE_UNIT_ADMIN],
  roleAdmin: [ROLE.HARDWARE_UNIT_ADMIN],
  singularName: (t: TFunction) => t("Hardware unit"),
  name: (t: TFunction) => t("Hardware units"),
  initialFilter: {
    assignment: "all",
  },
  syncCustomerFilter: true,
});

export default conf;
